import z from 'zod'

const PositionSchema = z.array(z.number()).min(2).max(3)
const LinearRingSchema = z.array(PositionSchema)

const PolygonSchema = z.object({
	type: z.literal('Polygon'),
	coordinates: z.array(LinearRingSchema),
})

const MultiPolygonSchema = z.object({
	type: z.literal('MultiPolygon'),
	coordinates: z.array(z.array(LinearRingSchema)),
})

export const GeometrySchema = z.preprocess(
	(value) => (typeof value === 'string' ? JSON.parse(value) : value),
	z.discriminatedUnion('type', [PolygonSchema, MultiPolygonSchema]),
)
